import ENDPOINT from "@/api/endpoints";
import { HTTP } from "@/api/http-common";

export function callApiGetListYearFilterHoSo(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.GET_YEAR_FILTER,
    method: "GET",
    params: payload,
  });
}

export function CallApiMaHoSo(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.LAP_HO_SO.GET_MA_HO_SO,
    method: "GET",
    params: payload,
  });
}

export function callApiGetDanhSachHoSoDuKien(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.GET_DANH_SACH_HO_SO_DU_KIEN,
    method: "POST",
    data: payload,
  });
}
export function callApiGetDanhSachHoSo(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.GET_DANH_SACH_HO_SO,
    method: "POST",
    data: payload,
  });
}
export function callApiThemMoiHoSoDuKien(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.THEM_HO_SO_DU_KIEN,
    method: "POST",
    data: payload,
  });
}

export function callApiSuaHoSoDuKien(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.EDIT_HO_SO_DU_KIEN,
    method: "PUT",
    data: payload,
  });
}

export function callApiGetChiTietHoSoDuKien(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.CHI_TIET_HO_SO_DU_KIEN}/${payload}`,
    method: "GET",
  });
}

export function callApiXoaHoSoDuKien(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.XOA_DANH_SACH_HS_DU_KIEN}/?id=${payload}`,
    method: "DELETE",
    data: payload,
  });
}

export function callApiXoaMultiHoSoDuKien(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.XOA_MULTI_HS_DU_KIEN}`,
    method: "DELETE",
    data: payload,
  });
}

export function callApiThemHoSoDuKien(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.THEM_HO_SO_DU_KIEN,
    method: "POST",
    data: payload,
  });
}

export function callApiGetDanhSachDanhMucHoSo(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.GET_DANH_SACH_DANH_MUC_HO_SO,
    method: "POST",
    data: payload,
  });
}

export function callApiThemMoiDanhMucHoSo(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.CREATE_DANH_MUC_HO_SO,
    method: "POST",
    data: payload,
  });
}

export function callApiSuaDanhMucHoSo(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.EDIT_DANH_MUC_HO_SO,
    method: "PUT",
    data: payload,
  });
}

export function callApiXoaDanhMucHoSo(data) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DANH_MUC_HO_SO}/${data}`,
    method: "DELETE",
    data: {},
  });
}

export function callApiGetChiTietDanhMucHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DANH_MUC_HO_SO}/${payload}`,
    method: "GET",
  });
}

export function callApiGetDataLoaiHoSo() {
  return HTTP({
    url: `${ENDPOINT.HSLT.LOAI_HO_SO.GET_ALL}`,
    method: "POST",
  });
}

export function callApiGetDanhSachCanBoTrinh(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DANH_SACH_CAN_BO_TRINH}`,
    method: "POST",
    data: payload,
  });
}

export function callLanhDaoDvDuyetHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.LANH_DAO_DV_DUYET_HO_SO}`,
    method: "POST",
    data: payload,
  });
}

export function callApiTrinhLanhDaoDonVi(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.TRINH_LANH_DAO_DON_VI}`,
    method: "POST",
    data: payload,
  });
}

export function callTraLaiDanhMucHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.TRA_LAI_DANH_MUC_HO_SO}`,
    method: "POST",
    data: payload,
  });
}

export function callApiGetDataNhomHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.NHOM_HO_SO.GET_ALL}`,
    method: "POST",
    data: payload,
  });
}

export function callApiGetCanBoNhanHoSoDuKien(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.GET_CAN_BO_NHAN_HO_SO_DU_KIEN}`,
    method: "POST",
    data: payload,
  });
}

export function callApiGuiDanhSachHoSoDuKien(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.GUI_DS_HO_SO_DU_KIEN}`,
    method: "PUT",
    data: payload,
  });
}

export function callApiGetDanhSachDeMuc(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DE_MUC.GET_ALL}`,
    method: "GET",
    params: payload,
  });
}

export function callApiGetDanhSachHoSoDuKienCuaDonVi(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.GET_DANH_SACH_HO_SO_DU_KIEN_DON_VI}`,
    method: "GET",
    params: payload,
  });
}

export function callApiGetDataChiTietDanhMucHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.CHI_TIET_DANH_MUC_HO_SO}`,
    method: "POST",
    data: payload,
  });
  }

export function callApiGetDanhSachDonViNopHoSoByYear(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DON_VI_NOP_HO_SO.GET_ALL}`,
    method: "POST",
    data: payload,
  });
}


export function callApiGetDanhSachDeYKien(params) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DANH_SACH_Y_KIEN(params.id)}`,
    method: "GET",
    params: params,
  })}

export function callApiSearchDonViNopHoSoById(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DON_VI_NOP_HO_SO.SEARCH}`,
    method: "GET",
    data: payload,
  });
}

export function callApiThemMoiDonViNopHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DON_VI_NOP_HO_SO.CREATE}`,
    method: "POST",
    data: payload,
  });
}

export function callApiXoaDonViNopHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DON_VI_NOP_HO_SO.DELETE}?id=${payload.id}`,
    method: "DELETE",
  });
}

export function callApiXoaNhieuDonViNopHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DON_VI_NOP_HO_SO.MULTI_DELETE}`,
    method: "DELETE",
    data: payload,
  });
}

export function callApiGetAllDonVi(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.DON_VI_NOP_HO_SO.GET_ALL_DON_VI}?nam=${payload.nam}`,
    method: "GET",
  });
}

export function callApiAddHoSo(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.LAP_HO_SO.CREATE}`,
    method: "POST",
    data: payload,
  });
}

export function callApiThemMoiDanhMucYKien(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.Y_KIEN.THEM,
    method: "POST",
    data: payload,
  });
}

export function callApiXoaDanhMucYKien(payload) {
  return HTTP({
    url: `${ENDPOINT.HSLT.Y_KIEN.XOA(payload.id)}`,
    method: "DELETE",
    data: payload,
  })}

export function callApiGetDanhSachLichSu(params) {
  return HTTP({
    url: `${ENDPOINT.HSLT.LICH_SU_CHI_TIET_DANH_MUC_HO_SO(params.id)}`,
    method: "GET",
    params: params,
  })}

  export function callApiSuaYKienDanhMuc(payload) {
    return HTTP({
      url: ENDPOINT.HSLT.Y_KIEN.SUA,
      method: "PUT",
      data: payload,
    });
  }

  export function callApiGetDanhSachLinhVuc(payload){
    return HTTP({
      url: ENDPOINT.HSLT.LINH_VUC.DANH_SACH_LINHV,
      method: "GET",
      data: payload,
    });
  }

  export function callApiGetDanhSachNguoiLapHoSo(payload){
    return HTTP({
      url: `${ENDPOINT.HSLT.DANH_SACH_NGUOI_LAP_HO_SO(payload.id)}`,
      method: "GET",
      params: payload,
    });
  }
